/* import __COLOCATED_TEMPLATE__ from './profile-overlay.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { IN_REACT_NATIVE } from '../constants/environment';
import { PROFILE_OVERLAY_SCROLL_VIEW_CLASS } from '../constants/components/profile';

const CLASS_NAME = 'SH-c-profile-overlay';

export default Component.extend({
  session: service(),

  tagName: '',
  CLASS_NAME,
  PROFILE_OVERLAY_SCROLL_VIEW_CLASS,
  IN_REACT_NATIVE,

  /** @param {'user'|'company'|null} type */
  type: null,

  /** @param {User|Company|null} model */
  model: null,

  /** @param {Boolean} useCarousel Whether to use the carousel mechanism. */
  useCarousel: false,

  /** @param {Boolean} carouselHasPrev Whether the carousel can move backward */
  carouselHasPrev: false,

  /** @param {Boolean} carouselHasNext Whether the carousel can move forward */
  carouselHasNext: false,

  /** @param {Function} onProfileOverlayClose */
  onProfileOverlayClose: () => {},

  /** @param {Function} onSetProfileOverlayModel */
  onSetProfileOverlayModel: () => {},

  /** @type {Ember.Component} The reference to the child profile component. */
  _profileRef: null,

  /** @type {String} The URL for the profile. */
  _profileURL: computed('type', 'model.slug', function () {
    const type = this.get('type');
    const slug = this.get('model.slug');

    switch (type) {
      case 'user':
        return `/${slug}`;
      case 'company':
        return `/company/${slug}`;
      default:
        return '';
    }
  }),

  /**
   * @param {JQuery.Event} event
   */
  _onKeyDownHandler(event) {
    if (event.keyCode !== 27) return;

    this._close();
  },

  /** Closes the carousel. */
  _close() {
    const profileRef = this.get('_profileRef');

    if (!profileRef) {
      this.get('onProfileOverlayClose')();
      return;
    }

    profileRef.cleanup().then(() => {
      this.get('onProfileOverlayClose')();
    });
  },

  /** @inheritDoc */
  init() {
    this._super(...arguments);

    this._onKeyDown = this._onKeyDownHandler.bind(this);
    document.body.addEventListener('keydown', this._onKeyDown);
  },

  /** @inheritDoc */
  willDestroy() {
    this._super(...arguments);
    document.body.removeEventListener('keydown', this._onKeyDown);
  },

  actions: {
    /** Called when the close button is clicked. */
    onCloseClicked() {
      this._close();
    },

    /** Called when the backdrop is clicked. */
    onBackdropClick() {
      this._close();
    },

    /** Called when the left arrow is clicked. */
    onPreviousClick() {
      if (!this.carouselHasPrev) return false;
      const profileRef = this.get('_profileRef');

      if (!profileRef) {
        this.get('onSetProfileOverlayModel')(-1);
        return;
      }

      profileRef.cleanup().then(() => {
        this.get('onSetProfileOverlayModel')(-1);
      });
    },

    /** Called when the right arrow is clicked. */
    onNextClick() {
      if (!this.carouselHasNext) return false;
      const profileRef = this.get('_profileRef');

      if (!profileRef) {
        this.get('onSetProfileOverlayModel')(1);
        return;
      }

      profileRef.cleanup().then(() => {
        this.get('onSetProfileOverlayModel')(1);
      });
    },

    /**
     * Called when the child profile component initializes.
     *
     * @param {Ember.Component} profile
     */
    handleSetProfileRef(profile) {
      this.set('_profileRef', profile);
    },
  },
});
